export const defaultWeekFields = {
  ble: {
    BLET1: 'defaultWeekT1',
    BLET2: 'defaultWeekT2',
    BLEDN: 'defaultWeekDn',
    BLET3: 'defaultWeekT3',
  },
  orge: {
    ORGET1: 'defaultWeekT1',
    ORGET2: 'defaultWeekT2',
    ORGET3: 'defaultWeekT3',
  },
  colza: {
    COLZASH: 'defaultWeek',
    COLZAEH: 'defaultWeek',
  },
};

export const personalizedDateFields = {
  ble: {
    BLET1: 't1_date_livraison',
    BLET2: 't2_date_livraison',
    BLEDN: 'dn_date_livraison',
    BLET3: 't3_date_livraison',
  },
  orge: {
    ORGET1: 't1_date_livraison',
    ORGET2: 't2_date_livraison',
    ORGET3: 't3_date_livraison',
  },
  colza: {
    COLZASH: 'sh_date_livraison',
    COLZAEH: 'eh_date_livraison',
  },
};

export const adviceTypeMap: { [key: string]: string } = {
  BLET1: 'T1',
  BLET2: 'T2',
  BLET3: 'T3',
  BLEDN: 'DN',
  ORGET1: 'T1',
  ORGET2: 'T2',
  ORGET3: 'T3',
  COLZASH: 'SH',
  COLZAEH: 'EH',
};
